import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@unite-us/app-components';
import Notifier from 'common/helpers/Notifier';
import { InReviewModal } from 'common/Workqueue/InReviewModal';

export const ReviewRequestButtonWithModal = ({
  onSubmit,
  modalTitle,
  reviewReasonsOptions,
  assigneeOptions,
  initialModalValues,
}) => {
  const modalRef = useRef(null);

  const handleOpenModalClick = () => {
    if (modalRef.current) {
      modalRef.current.openModal();
    }
  };

  const handleSubmit = async (data) => {
    try {
      await onSubmit(data);
    } catch (error) {
      Notifier.handleErrors(error);
    }
  };

  return (
    <>
      <Button
        onClick={handleOpenModalClick}
        label="Review"
        outline
        size="small"
        icon={{
            color: '#4467AB',
            name: 'FileTextO', // TODO: update icon to FileInReview
            position: 'left',
        }}
      />
      <InReviewModal
        ref={modalRef}
        title={modalTitle}
        onSubmit={handleSubmit}
        assigneeOptions={assigneeOptions}
        reviewReasonOptions={reviewReasonsOptions}
        initialFormValues={initialModalValues}
      />
    </>
  );
};

ReviewRequestButtonWithModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  modalTitle: PropTypes.string.isRequired,
  reviewReasonsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  assigneeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  initialModalValues: PropTypes.shape({
    review_reason: PropTypes.string.isRequired,
    in_review_note: PropTypes.string.isRequired,
    assignee: PropTypes.string.isRequired,
  }),
};

ReviewRequestButtonWithModal.defaultProps = {
  initialModalValues: null,
};
